module.exports = __webpack_public_path__ + "media/images/icons/quote-big-08dc59116021e1edc7bdd70f4a42de2e.svg";